import React from 'react'

import { Card } from '@grandvisionhq/common'
import type { SummarySlotType } from '@grandvisionhq/lib-form-slots'
import { useIntl } from '@grandvisionhq/state'

// Concatenates only truthy values
function concat(values: Array<string | number | undefined | null>, delimiter: string = ' ') {
  return values.filter(Boolean).join(delimiter)
}

export const PreferredStoreSummary: SummarySlotType<{
  values?: {
    storeName: string
    streetName: string
    streetNumber: string
    postalCode: string
    town: string
  }
}> = ({ actions, values }) => {
  const { getLabel } = useIntl()
  const LABEL_EDIT = getLabel('common.actions.edit')

  return (
    <Card>
      <Card.Content>
        <Card.Actions>
          {actions?.onEdit && <Card.Button onClick={actions.onEdit} children={LABEL_EDIT} />}
        </Card.Actions>
        {values?.storeName && <Card.Text variant="body-head">{values?.storeName}</Card.Text>}
        <Card.Text>{concat([values?.streetName, values?.streetNumber])}</Card.Text>
        <Card.Text>{concat([values?.town, values?.postalCode])}</Card.Text>
      </Card.Content>
    </Card>
  )
}
